import Vue from 'vue'
import App from './App'
import router from './router'
import request from "./request/index"
import store from './store/index'

//  引入element组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import LYUtils from '@/common/LYUtils.js';
import LYCom from '@/common/LYCom.js';
Vue.use(ElementUI);
// 打印插件
import Print from 'vue-print-nb'
Vue.use(Print);
const sysSvr = LYCom.GetSvrById("sysSvr").Address;
const imgUrl = LYCom.GetSvrById("OssImgUrl").Address;
const chatUrl = LYCom.GetSvrById("chatUrl").Address;
const noticeUrl = LYCom.GetSvrById("noticeUrl").Address;
const chatFilUrl = LYCom.GetSvrById("chatFilUrl").Address;
const schoolSvr = LYCom.GetSvrById("schoolSvr").Address; //学校本地
const uploadFile = LYCom.GetSvrById("uploadFile").Address; // 文件上传地址
const CounselingFileSvr = LYCom.GetSvrById("CounselingFileSvr").Address; // 咨询附件地址

Vue.prototype.$CounselingFileSvr = CounselingFileSvr;
Vue.prototype.$schoolSvr = schoolSvr;
Vue.prototype.$uploadFile = uploadFile; // 文件上传地址
Vue.prototype.$sysSvr = sysSvr; // 系统地址
Vue.prototype.$imgUrl = imgUrl;
Vue.prototype.$chatUrl = chatUrl;
Vue.prototype.$noticeUrl = noticeUrl;
Vue.prototype.$LYUtils = LYUtils;
Vue.prototype.$chatFilUrl = chatFilUrl;
Vue.prototype.$LYCom = LYCom;


Vue.config.productionTip = false
Vue.prototype.$axios = request
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js